import React from 'react';
import { useNavigate, useLocation, matchPath } from 'react-router';
import url from 'url';
import ListRoutes from '@gral/routes';
import { IRoute, IRouterProps } from '@interfaces/App.interface';
import { TMode } from '@ts/ui-models';

const getMode = (path: string): TMode => {
  if (path.endsWith('view')) {
    return 'view';
  } else if (path.endsWith('edit')) {
    return 'edit';
  } else if (path.endsWith('new')) {
    return 'new';
  }
  return '';
};
function WithRouter<P extends IRouterProps>(WrappedComponent: React.ComponentType<P>) {
  const WithRouterComponent = (props: any, ref: React.Ref<any>) => {
    const listRoutes: IRoute[] = ListRoutes;
    const navigate = useNavigate();
    const location = useLocation();

    console.log('WithRouter remove');
    const parsedUrl = url.parse(location.pathname + location.search, true);
    let route = listRoutes.find(r => matchPath(r.matchPath, location.pathname));

    const transferPropsRoute = React.useMemo(() => {
      if (route) {
        const params = matchPath(route.matchPath, location.pathname)?.params;
        return {
          id: route.id,
          path: location.pathname + location.search,
          params,
          location,
          query: parsedUrl.query,
        };
      }
      return {};
    }, [route, location.pathname, location.search, parsedUrl.query]);

    const mode = React.useMemo(() => {
      return getMode(location.pathname);
    }, [location.pathname]);

    return (
      <WrappedComponent
        ref={ref}
        {...(props as P)}
        mode={mode}
        navigate={navigate}
        location={location}
        transferPropsRoute={transferPropsRoute}
      />
    );
  };

  return React.forwardRef(WithRouterComponent);
}

export default WithRouter;
